export default __webpack_public_path__ + "fbbbd6bb596bb076335cbbafcd7fd0ea.png";